import React from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  useTheme,
  Typography,
  useMediaQuery,
} from "@mui/material/";

import Container from "../Layout/Container";
import t__ from "../../util/lang/util";
import intro from "../../util/lang/intro";
import bgSurfer from "./images/offers-surfers.jpg";

const PREFIX = "IntroCallout";

const classes = {
  calloutHeadline: `${PREFIX}-calloutHeadline`,
  calloutPhoto: `${PREFIX}-calloutPhoto`,
  lightBlueBtn: `${PREFIX}-lightBlueBtn`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.calloutHeadline}`]: {
    maxWidth: 325,
    marginBottom: "24px",
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: "bold",
    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      lineHeight: "36px",
    },
  },

  [`& .${classes.calloutPhoto}`]: {
    backgroundSize: "cover",
    backgroundImage: `url(${bgSurfer})`,
    backgroundPosition: "center",
    minHeight: "181px",
    [theme.breakpoints.up("md")]: {
      minHeight: "292px",
    },
  },

  [`& .${classes.lightBlueBtn}`]: {
    backgroundColor: "#d2eefa",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "10px 20px",
    transition: "all .4s",
    color: "#000000",
    "&:hover, &:focus": {
      backgroundColor: "white",
      color: theme.palette.primary.main,
    },
  },
}));

const IntroCallout = () => {
  const theme = useTheme();

  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <StyledBox display="flex" width="100%" py={20}>
      <Container>
        <Box
          display="flex"
          borderRadius="12px"
          overflow="hidden"
          width="100%"
          flexDirection={isMediumScreen ? "row" : "column"}
        >
          <Box
            width={{ xs: 1, md: 1 / 2 }}
            bgcolor={`${theme.palette.secondary.main}`}
            color={`${theme.palette.common.white}`}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            px={5}
            py={10}
            minHeight={isMediumScreen ? "292px" : "181px"}
          >
            <Typography
              component="h2"
              className={classes.calloutHeadline}
              align="center"
            >
              {t__(theme.lang, intro, "promoCallout")}
            </Typography>
            <Button
              href="https://www.unionpayintl.com/cardholderServ/serviceCenter/merchant?country=10040351&offerFlag=1&countryFlag=1&language=cn&isOderBy=1&globalCard=y"
              className={classes.lightBlueBtn}
            >
              {t__(theme.lang, intro, "promoCalloutCTA")}
            </Button>
          </Box>
          <Box
            width={{ xs: 1, md: 1 / 2 }}
            className={classes.calloutPhoto}
          ></Box>
        </Box>
      </Container>
    </StyledBox>
  );
};

export default IntroCallout;
